<!--TOP PANEL-->

<c-row id="top-panel" [ngClass]="{ 'top-panel-disabled': disabled }">
  <c-col class="col-1" id="btn-hamburger-col">
    <span
      id="btn-hamburger"
      tabindex="0"
      role="button"
      class="m-2"
      (click)="toggleSidebar()"
      (keydown)="onKeydown($event)"
    >
      <i class="collapse-icon fal fa-bars" [ngClass]="{ 'btn-hamburger-expended': isSidebarExpanded }"></i>
    </span>
  </c-col>

  <c-col>
    <app-logo width="150" height="33"></app-logo>
    <span id="app-version">{{ systemVersion }}</span>
  </c-col>

  @if (hasAgentScreenPermission) {
    <c-col style="max-width: 120px">
      <button
        id="show-agent-btn"
        cButton
        color="info"
        (click)="openAgentScreen()"
        size="sm"
        class="text-white"
        [disabled]="!systemService.selectedProject"
      >
        {{ 'TOP_PANEL_BUTTON_SHOW_AGENT_SCREEN' | translate }}
      </button>
    </c-col>
  }

  <c-col style="max-width: 8px" class="pe-0 ps-0 d-flex align-items-center">
    <div class="divider vr mx-2 text-gray" style="height: 32px"></div>
  </c-col>
  @if (showCompanySelect) {
    <c-col style="max-width: 200px" class="pe-1">
      <ng-select
        #companySelect
        id="list-companies"
        class="custom-select top-panel-text"
        [(ngModel)]="systemService.selectedCompany"
        [items]="systemService.filteredCompaniesOptions()"
        (search)="systemService.updateCompanySearch($event.term)"
        (open)="systemService.updateCompanySearch('')"
        (change)="onCompanyChange($event)"
        bindLabel="label"
        bindValue="value"
        [searchFn]="searchAllFn"
        [searchable]="true"
        [clearable]="false"
        [inputAttrs]="{ autocomplete: 'off', 'data-form-type': 'other', 'data-lpignore': 'true' }"
      >
      </ng-select>
    </c-col>
  }

  <c-col style="max-width: 200px" class="ps-1 pe-1">
    <ng-select
      #projectSelect
      id="list-projects"
      class="custom-select top-panel-text"
      [(ngModel)]="systemService.selectedProject"
      [items]="systemService.projectsListOptions()"
      bindLabel="label"
      bindValue="value"
      placeholder="select project"
      [clearable]="false"
      [searchable]="true"
      (change)="onProjectChange($event)"
      [inputAttrs]="{ autocomplete: 'off', 'data-form-type': 'other', 'data-lpignore': 'true' }"
    >
    </ng-select>
  </c-col>

  <c-col style="max-width: 10px" class="pe-0 ps-0 d-flex align-items-center">
    <div class="divider vr mx-2 text-gray" style="height: 32px"></div>
  </c-col>

  <c-col style="max-width: 240px; margin-right: 90px">
    <div id="unified-user-menu" class="user-menu-container">
      <div class="menu-toggle" (click)="toggleUserMenu($event)">
        <span class="user-welcome">
          <i class="fad fa-caret-down toggle-icon" [class.rotated]="userMenuExpanded" style="color: #000"></i>
          {{ 'TOP_PANEL_USER_MENU_WELCOME' | translate }} {{ authService.user?.firstName }}
          <i
            [ngClass]="authService.user?.isSuperuser ? `${iconsStyle} fa-user-astronaut` : `${iconsStyle} fa-user`"
            style="padding-left: 10px"
          >
          </i>
        </span>
      </div>
      <ul class="menu-dropdown" [ngClass]="{ 'menu-expanded': userMenuExpanded }">
        <li id="user-profile" class="menu-item" (click)="loadUserProfile(); userMenuExpanded = false">
          <a>
            <i [ngClass]="`${iconsStyle} ${icons.user} margin-right-5`"></i>
            {{ 'TOP_PANEL_USER_MENU_PROFILE' | translate }}
          </a>
        </li>
        <li id="user-logout" class="menu-item" (click)="onLogoutClick(); userMenuExpanded = false">
          <a>
            <i [ngClass]="`${iconsStyle} ${icons.powerOff} margin-right-5`"></i>
            {{ 'TOP_PANEL_USER_MENU_LOGOUT' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </c-col>
</c-row>
